<template>
    <el-dialog :visible="visible" width="" :before-close="onClose" :close-on-click-modal="false" class="ah-detail-dialog re-calculate-dialog" id="">
        <template slot="title"> 系統重算 </template>
        <div class="detail-row" style="padding-top: 30px">
            <div class="detail-block">
                <div class="detail-block-inner">
                    <div class="image-box">
                        <img v-if="isLoading" src="@/assets/img/dialog/re-calculate/loading.gif" alt="" />
                        <img v-else src="@/assets/img/dialog/re-calculate/static.png" alt="" />
                    </div>
                    <div class="text-box">
                        <div>
                            補登非本月帳款之後，需要執行系統重算來校正統計數據。重算期間請耐心等候。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="detail-row footer" style="text-align: center">
            <el-button type="primary" class="primary-action" :disabled="isLoading" @click="onReCalculate">{{ isLoading ? "重算中..." : "開始重算" }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    data() {
        return {
            isLoading: false,
        };
    },
    computed: {
        ...mapState({
            visible: (state) => state.globalDialogState.reCalculateDialogVisible,
        }),
    },
    methods: {
        ...mapMutations({
            updateReCalculateDialogVisible: 'globalDialogState/updateReCalculateDialogVisible',
        }),
        onClose() {
            this.updateReCalculateDialogVisible(false);
        },
        async onReCalculate() {
            this.isLoading = true;
            try {
                await this.$api({
                    url: 'Tool/ResetAccountRecords',
                    method: 'GET',
                });
                this.$message({
                    showClose: true,
                    message: '系統重算完成。',
                    type: 'success',
                });
                setTimeout(() => {
                    this.$router.go();
                }, 1000);
            } catch (e) {
                console.log(e);
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss">
.ah-detail-dialog.re-calculate-dialog {
    display: flex;
    .el-dialog {
        width: 100%;
        max-width: 550px;
        margin: auto !important;
    }
    .detail-block-inner {
        margin: 30px 0;
        .image-box {
            margin: auto;
            max-width: 150px;
            img {
                width: 100%;
            }
        }
        .text-box {
            text-align: center;
            max-width: 310px;
            margin: 20px auto 0;
        }
    }
}
</style>
